import { FormikProps } from 'formik';
import React from 'react';
import { ComposableDeviceValues } from '../AddComposableDevice';
import { Stack } from '@mui/material';
import { IconUpload } from '../../../../../redux/groups/groups.model';
import ImageUploader from './ImageDropUpload';

export const ImageForm = ({
  formik,
  setLogo,
  setImage,
  logo,
}: {
  formik: FormikProps<ComposableDeviceValues>;
  image: IconUpload | null;
  setLogo: React.Dispatch<React.SetStateAction<IconUpload | null>>;
  setImage: React.Dispatch<React.SetStateAction<IconUpload | null>>;
  logo: IconUpload | null;
  closeAddComposableDevice?: () => void;
}) => {
  const onLogoChange = (image: IconUpload | null) => {
    setLogo(image);
    setImage(image);
    formik.setFieldValue('logoURL', image?.imagePreviewUrl || null);
    formik.setFieldValue('imageURL', image?.imagePreviewUrl || null);
  };

  return (
    <Stack
      display={'flex'}
      flexDirection={'column'}
      spacing={2}
      alignItems={'flex-start'}
      justifyContent={'space-between'}
    >
      <ImageUploader
        initialImage={logo?.imagePreviewUrl}
        onImageChange={onLogoChange}
      />
    </Stack>
  );
};
